import { SkyBoxRoutesEnum } from "models/enums/apiRoutes/skyBoxApiRoutes";
import {
  IBrokerList,
  IBuyerList,
  IEventList,
  IDistinctEventList,
  IVenueList,
  IDateList,
  ICardList,
  IAlertList,
  ICurrencyList,
  IReportList,
  IRecipientList,
  ISkyboxUserList,
  IRoleList,
  ISplitTypeList,
  IBuyerTagList,
  IListerTagList,
  ITicketbashBrokerList,
  ISaleCategoryList,
  ICustomerClassificationList,
  IStateList,
  ISeatIntelligenceList,
  IScrapingStatusList,
  IListerUserList,
  IBrokerUserList,
  INewVenueList,
  IPaymentStatusesList,
  IAgingPeriodsList,
  ISeatMapCreatorUserList,
  ICheckerUserList,
  IFulfillmentStatusesList,
  IBuyerUserList,
  IShipperList,
  ISkyboxVendorList,
  IInventoryCancellationTypesList,
} from "models/interfaces";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";

class FilterOptionsService {
  public getBrokerTagsByReportId = async (queryParams: {
    current_report_id: number;
  }) => {
    return axiosClient.get<IApiBaseResponse<IBrokerList>>(
      SkyBoxRoutesEnum.BROKER_TAGS_BY_REPORT_ID,
      { params: { ...queryParams } }
    );
  };

  public getBuyers = async () => {
    return axiosClient.get<IApiBaseResponse<IBuyerList>>(SkyBoxRoutesEnum.BUYER_LIST);
  };

  public getShippers = async () => {
    return axiosClient.get<IApiBaseResponse<IShipperList>>(
      SkyBoxRoutesEnum.SHIPPER_LIST
    );
  };

  public getEvents = async () => {
    return axiosClient.get<IApiBaseResponse<IEventList>>(SkyBoxRoutesEnum.EVENT_LIST);
  };

  public getDistinctEventList = async () => {
    return axiosClient.get<IApiBaseResponse<IDistinctEventList>>(
      SkyBoxRoutesEnum.DISTINCT_EVENT_LIST
    );
  };

  public getVenues = async () => {
    return axiosClient.get<IApiBaseResponse<IVenueList>>(SkyBoxRoutesEnum.VENUE_LIST);
  };

  public getDateRange = async () => {
    return axiosClient.get<IApiBaseResponse<IDateList>>(SkyBoxRoutesEnum.DATE_RANGE);
  };

  public getCards = async () => {
    return axiosClient.get<IApiBaseResponse<ICardList>>(SkyBoxRoutesEnum.CARD_LIST);
  };

  public getAlerts = async () => {
    return axiosClient.get<IApiBaseResponse<IAlertList>>(SkyBoxRoutesEnum.ALERT_LIST);
  };

  public getCurrencies = async () => {
    return axiosClient.get<IApiBaseResponse<ICurrencyList>>(
      SkyBoxRoutesEnum.CURRENCY_LIST
    );
  };

  //NEW
  public getReports = async (queryParams: { current_report_id: number }) => {
    return axiosClient.get<IApiBaseResponse<IReportList>>(
      SkyBoxRoutesEnum.REPORT_LIST,
      { params: { ...queryParams } }
    );
  };

  public getRecipients = async () => {
    return axiosClient.get<IApiBaseResponse<IRecipientList>>(
      SkyBoxRoutesEnum.RECIPIENT_LIST
    );
  };

  public getSkyBoxUsers = async () => {
    return axiosClient.get<IApiBaseResponse<ISkyboxUserList>>(
      SkyBoxRoutesEnum.SKYBOX_USER_LIST
    );
  };

  public getSkyBoxVendors = async () => {
    return axiosClient.get<IApiBaseResponse<ISkyboxVendorList>>(
      SkyBoxRoutesEnum.SKYBOX_VENDORS
    );
  };

  public getRoles = async () => {
    return axiosClient.get<IApiBaseResponse<IRoleList>>(SkyBoxRoutesEnum.ROLE_LIST);
  };

  public getSplitTypes = async () => {
    return axiosClient.get<IApiBaseResponse<ISplitTypeList>>(
      SkyBoxRoutesEnum.SPLIT_TYPE_LIST
    );
  };

  public getBuyerTypes = async () => {
    return axiosClient.get<IApiBaseResponse<IBuyerTagList>>(
      SkyBoxRoutesEnum.BUYER_TAG_LIST
    );
  };

  public getListerTypes = async () => {
    return axiosClient.get<IApiBaseResponse<IListerTagList>>(
      SkyBoxRoutesEnum.LISTER_TAG_LIST
    );
  };

  public getTicketbashBrokerList = async () => {
    return axiosClient.get<IApiBaseResponse<ITicketbashBrokerList>>(
      SkyBoxRoutesEnum.TICKETBASH_BROKER_LIST
    );
  };

  public getSaleCategories = async () => {
    return axiosClient.get<IApiBaseResponse<ISaleCategoryList>>(
      SkyBoxRoutesEnum.SALE_CATEGORY_LIST
    );
  };

  public getCustomerClassifications = async () => {
    return axiosClient.get<IApiBaseResponse<ICustomerClassificationList>>(
      SkyBoxRoutesEnum.CUSTOMER_CLASSIFICATION_LIST
    );
  };

  public getStates = async () => {
    return axiosClient.get<IApiBaseResponse<IStateList>>(SkyBoxRoutesEnum.STATE_LIST);
  };

  public getInventoryCancellationTypes = async () => {
    return axiosClient.get<IApiBaseResponse<IInventoryCancellationTypesList>>(SkyBoxRoutesEnum.INVENTORY_CANCELLATION_TYPE_LIST);
  };

  public getSeatIntelligenceDetails = async () => {
    return axiosClient.get<IApiBaseResponse<ISeatIntelligenceList>>(
      SkyBoxRoutesEnum.SEAT_INTELLIGENCE_DETAILS
    );
  };

  public getScrapingStatusDetails = async () => {
    return axiosClient.get<IApiBaseResponse<IScrapingStatusList>>(
      SkyBoxRoutesEnum.SCRAPING_STATUS_DETAILS
    );
  };

  public getBrokerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<IBrokerUserList>>(
      SkyBoxRoutesEnum.BROKER_USER_LIST
    );
  };

  public getBuyerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<IBuyerUserList>>(
      SkyBoxRoutesEnum.BUYER_USER_LIST
    );
  };

  public getListerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<IListerUserList>>(
      SkyBoxRoutesEnum.LISTER_USER_LIST
    );
  };

  public getSeatMapCreatorUserList = async () => {
    return axiosClient.get<IApiBaseResponse<ISeatMapCreatorUserList>>(
      SkyBoxRoutesEnum.SEAT_MAP_CREATOR_USER_LIST
    );
  };

  public getCheckerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<ICheckerUserList>>(
      SkyBoxRoutesEnum.CHECKER_USER_LIST
    );
  };

  public getVenuesDatePresets = async () => {
    return axiosClient.get<IApiBaseResponse<INewVenueList>>(
      SkyBoxRoutesEnum.VENUE_DATE_PRESETS
    );
  };

  public getPaymentStatusList = async () => {
    return axiosClient.get<IApiBaseResponse<IPaymentStatusesList>>(
      SkyBoxRoutesEnum.ZONE_PAYMENT_STATUS_LIST
    );
  };

  public getAgingPeriodList = async () => {
    return axiosClient.get<IApiBaseResponse<IAgingPeriodsList>>(
      SkyBoxRoutesEnum.AGING_PERIODS_LIST
    );
  };

  public getFulfillmentStatusList = async () => {
    return axiosClient.get<IApiBaseResponse<IFulfillmentStatusesList>>(
      SkyBoxRoutesEnum.FULFILLMENT_STATUSES_LIST
    );
  };

  public getShowCategories = async () => {
    return axiosClient.get<IApiBaseResponse>(SkyBoxRoutesEnum.SHOW_CATEGORIES);
  };

  public getVenueScrapingTypes = async () => {
    return axiosClient.get<IApiBaseResponse>(SkyBoxRoutesEnum.VENUE_SCRAPING_TYPES);
  };
}

export { FilterOptionsService };
